import React from "react";
import { Drawer } from "rsuite";
import AboutContent from "./AboutContent";

const AboutTab = ({ allRooms, openVar, openMethod }) => {
  return (
    <Drawer
      placement={"bottom"}
      open={openVar}
      onClose={() => openMethod(false)}
      size={"full"}
      backdrop={true}
    >
      <Drawer.Header>Über loc.ur.de</Drawer.Header>
      <Drawer.Body>
        <AboutContent allRooms={allRooms} />
      </Drawer.Body>
    </Drawer>
  );
};

export default AboutTab;
